import { Grid } from "@mui/material";

import Facebook from "assets/images/about-us/Facebook.svg";
import Twitter from "assets/images/about-us/Twitter.svg";
import Apple from "assets/images/about-us/Apple.svg";
import Nfl from "assets/images/about-us/Nfl.svg";
import Nike from "assets/images/about-us/Nike.svg";
import Amc from "assets/images/about-us/Amc.svg";
import StarWars from "assets/images/about-us/Star-Wars.svg";
import Universal from "assets/images/about-us/Universal.svg";
import SonyPictures from "assets/images/about-us/Sony-pictures.svg";

import { StyledGrid, Logo } from "./styles";

const FACEBOOK = { logo: Facebook, alt: "Facebook" };
const TWITTER = { logo: Twitter, alt: "Twitter" };
const APPLE = { logo: Apple, alt: "Apple" };
const NFL = { logo: Nfl, alt: "NFL" };
const NIKE = { logo: Nike, alt: "Nike" };
const AMC = { logo: Amc, alt: "AMC" };
const STAR_WARS = { logo: StarWars, alt: "Star Wars" };
const UNIVERSAL = { logo: Universal, alt: "Universal" };
const SONY_PICTURES = { logo: SonyPictures, alt: "Sony Pictures" };

const LOGOS = [FACEBOOK, TWITTER, APPLE, NFL, NIKE, AMC, STAR_WARS, UNIVERSAL, SONY_PICTURES];

const AboutUsPartnerLogos = () => {
  return (
    <Grid container justifyContent="center" textAlign="center" spacing={1} mb={5}>
      {LOGOS.map((item) => (
        <StyledGrid item xs={4} sm={2.4} key={item.alt} justifyContent="center">
          <Logo src={item.logo} alt={item.alt} />
        </StyledGrid>
      ))}
    </Grid>
  );
};

export default AboutUsPartnerLogos;
